import * as pdfMake from 'pdfmake/build/pdfmake';
import { addRobotoNormal } from './roboto-normal.js';

// This is a custom function to bridge your existing roboto-normal.js with pdfmake
const setupPdfMakeFonts = () => {
  // Ensure the VFS object exists before we try to add to it. This is the fix.
  if (!(pdfMake as any).vfs) {
    (pdfMake as any).vfs = {};
  }

  // A mock jsPDF object to call your existing function
  const mockJsPDF = {
    API: {
      addFileToVFS: (filename: string, data: string) => {
        // Add the font data to pdfMake's VFS
        (pdfMake as any).vfs[filename] = data;
      }
    }
  };

  // Call the function from your file to populate the VFS
  addRobotoNormal(mockJsPDF);

  // Configure pdfMake to use the Roboto font
  (pdfMake as any).fonts = {
    Roboto: {
      normal: 'Roboto-Regular.ttf',
      bold: 'Roboto-Regular.ttf', // Using regular for all styles as per your file
      italics: 'Roboto-Regular.ttf',
      bolditalics: 'Roboto-Regular.ttf',
    },
  };
};

export default setupPdfMakeFonts; 